<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-3">
            <yt-fw-date-picker-popup name="txtOdDatuma" formControlName="OdDatuma" [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                [Label]="'PROMETKASE.ODDATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                <span *ngFor="let validation of errorMessages.OdDatuma">
                    <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
        <div class="col-md-3">
            <yt-fw-date-picker-popup name="txtDoDatuma" formControlName="DoDatuma" [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                [Label]="'PROMETKASE.DODATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                <span *ngFor="let validation of errorMessages.DoDatuma">
                    <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-6">
            <label for="rdbVrstaIzvestaja" class="control-label col-md-2"><span>Tip izveštaja: </span></label>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" value="1" formControlName="VrstaIzvestaja">
                <span class="form-check-label" translate="PROMETKASE.KOMPLETNO"></span>
            </div>
            <div class="form-check form-check-inline ml-2">
                <input class="form-check-input" type="radio" value="2" formControlName="VrstaIzvestaja">
                <span class="form-check-label" translate="PROMETKASE.BEZSTAVKI"></span>
            </div>
            <div class="form-check form-check-inline ml-2">
                <input class="form-check-input" type="radio" value="3" formControlName="VrstaIzvestaja">
                <span class="form-check-label" translate="PROMETKASE.BEZSTAVKIIRACUNA"></span>
            </div>

            <button type="button" class="btn btn-primary" (click)="LoadPDF()">
                <span class="fa fa-fw fa-print"></span>Promet kase po korisnicima
            </button>
        </div>

    </div>

</form>